module.exports = __webpack_public_path__ + "static/media/ecomerce.135579f6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/gifs/ecomerce.gif
// module id = 68
// module chunks = 0